<template>
  <div class="container" id="imprimir">
    <div class="d-flex align-items-md-start justify-content-between flex-column">
      <div style="padding: 20px">

        <!-- Cabeçalho -->
        <img src="@/assets/logoBlack.png" alt="[logo]" style="width: 60%; margin: 10px 20%" />
        <div class="text-center" style="margin-bottom: 10px"><u>FECHAMENTO DO CAIXA</u></div>
        <div class="text-left" style="margin-bottom: 5px">Agência: {{ agencia.nome }}</div>
        <div class="text-left" style="margin-bottom: 5px">Operador: {{ operador.login }}</div>
        <div class="text-left" style="margin-bottom: 5px">Referente ao dia: {{ convertDate(data) }}</div>
        <div class="text-left" style="margin-bottom: 10px; border-bottom: 1px dashed #000">
          Emissão: {{ dataHora }}
        </div>

        <!-- RESUMO DE VALORES -->
        <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>RESUMO DE VALORES</u></div>
        <div style="padding: 5px">
          Dinheiro <span class="float-right">R$ {{ fmtVal(getForma('Dinheiro')) }}</span>
        </div>
        <div style="border-top: 1px dashed #000; padding: 5px">
          PIX <span class="float-right">R$ {{ fmtVal(getPix()) }}</span>
        </div>
        <div style="border-top: 1px dashed #000; padding: 5px">
          Cartão de Crédito <span class="float-right">R$ {{ fmtVal(getCartao()) }}</span>
        </div>
        <div v-if="parseVal(resumo.total_entradas_valor) > 0" style="border-top: 1px dashed #000; padding: 5px">
          Entrada Manual <span class="float-right">R$ {{ resumo.total_entradas_valor }}</span>
        </div>
        <div v-if="parseVal(resumo.total_saidas_valor) > 0" style="border-top: 1px dashed #000; padding: 5px">
          Saída Manual <span class="float-right">R$ {{ resumo.total_saidas_valor }}</span>
        </div>
        <div style="border-top: 2px solid #000; margin-top: 5px; padding-top: 5px">
          Subtotal (sem PIX) <span class="float-right">R$ {{ calcSubtotal() }}</span>
        </div>
        <div style="padding: 5px">
          PIX <span class="float-right">R$ {{ fmtVal(getPix()) }}</span>
        </div>
        <div style="border-top: 2px solid #000; padding: 5px; font-weight: bold; margin-bottom: 10px">
          TOTAL <span class="float-right">R$ {{ calcTotal() }}</span>
        </div>

        <!-- ABERTURA DO CAIXA -->
        <div class="text-left" style="border-bottom: 1px dashed #000"></div>
        <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>ABERTURA DO CAIXA</u></div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Valor <span class="float-right">R$ {{ totais.abertura }}</span>
        </div>

        <!-- ENTRADAS MANUAIS (só se houver) -->
        <div v-if="entradas && entradas.length > 0">
          <div class="text-left" style="border-bottom: 1px dashed #000"></div>
          <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>ENTRADAS MANUAIS</u></div>
          <div v-for="item in entradas" :key="item.id" style="padding: 5px; border-bottom: 1px dashed #000">
            <div>Descrição: {{ item.descricao }}</div>
            <div>Valor R$: <span class="float-right">{{ item.valor }}</span></div>
          </div>
          <div style="padding: 5px; font-weight: bold; border-bottom: 2px solid #000">
            Total <span class="float-right">R$ {{ resumo.total_entradas_valor }}</span>
          </div>
        </div>

        <!-- SAIDAS MANUAIS (só se houver) -->
        <div v-if="saidas && saidas.length > 0">
          <div class="text-left" style="border-bottom: 1px dashed #000"></div>
          <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>SAIDAS MANUAIS</u></div>
          <div v-for="item in saidas" :key="item.id" style="padding: 5px; border-bottom: 1px dashed #000">
            <div>Descrição: {{ item.descricao }}</div>
            <div>Valor R$: <span class="float-right">{{ item.valor }}</span></div>
          </div>
          <div style="padding: 5px; font-weight: bold; border-bottom: 2px solid #000">
            Total <span class="float-right">R$ {{ resumo.total_saidas_valor }}</span>
          </div>
        </div>

        <!-- VENDAS DE PASSAGENS -->
        <div class="text-left" style="border-bottom: 1px dashed #000"></div>
        <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>VENDAS DE PASSAGENS</u></div>
        <div style="padding: 5px">{{ totais.passagens_vendidas }} Passagens vendidas</div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Dinheiro <span class="float-right">R$ {{ fmtVal(getSectionForma(resumo.passagem, 'Dinheiro')) }}</span>
        </div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          PIX <span class="float-right">R$ {{ fmtVal(getSectionForma(resumo.passagem, 'Pix', 'PIX')) }}</span>
        </div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Cartão de Crédito <span class="float-right">R$ {{ fmtVal(getSectionCartao(resumo.passagem)) }}</span>
        </div>
        <div style="padding: 5px; font-weight: bold; border-bottom: 2px solid #000">
          Total <span class="float-right">R$ {{ totais.vendas }}</span>
        </div>

        <!-- EXCESSO DE BAGAGEM -->
        <div class="text-left" style="border-bottom: 1px dashed #000"></div>
        <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>EXCESSO DE BAGAGEM</u></div>
        <div style="padding: 5px">{{ resumo.excesso_count }} Excessos emitidos</div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Dinheiro <span class="float-right">R$ {{ fmtVal(getSectionForma(resumo.excesso, 'Dinheiro')) }}</span>
        </div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          PIX <span class="float-right">R$ {{ fmtVal(getSectionForma(resumo.excesso, 'Pix', 'PIX')) }}</span>
        </div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Cartão de Crédito <span class="float-right">R$ {{ fmtVal(getSectionCartao(resumo.excesso)) }}</span>
        </div>
        <div style="padding: 5px; font-weight: bold; border-bottom: 2px solid #000">
          Total <span class="float-right">R$ {{ totais.exc }}</span>
        </div>

        <!-- ENCOMENDAS -->
        <div class="text-left" style="border-bottom: 1px dashed #000"></div>
        <div class="text-center" style="margin-bottom: 5px; margin-top: 10px"><u>ENCOMENDAS</u></div>
        <div style="padding: 5px">{{ totais.encomendas_realizadas }} Encomendas</div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Dinheiro <span class="float-right">R$ {{ fmtVal(getSectionForma(resumo.encomenda, 'Dinheiro')) }}</span>
        </div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          PIX <span class="float-right">R$ {{ fmtVal(getSectionForma(resumo.encomenda, 'Pix', 'PIX')) }}</span>
        </div>
        <div style="border-bottom: 1px dashed #000; padding: 5px">
          Cartão de Crédito <span class="float-right">R$ {{ fmtVal(getSectionCartao(resumo.encomenda)) }}</span>
        </div>
        <div style="padding: 5px; font-weight: bold; border-bottom: 2px solid #000">
          Total <span class="float-right">R$ {{ totais.total_encomendas }}</span>
        </div>

        <!-- Footer -->
        <div class="text-center" style="margin-bottom: 10px; margin-top: 10px">
          <div style="border-top: 1px solid #000; margin-top: 50px"></div>
          <p>OPERADOR: {{ operador.login }}</p>
          <div style="border-top: 1px solid #000; margin-top: 30px"></div>
          <p>CPF</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dados", "data", "saidas", "entradas", "totais", "valores", "resumo"],
  data() {
    return {
      agencia: { nome: "" },
      dataHora: "",
      operador: { login: "" },
    };
  },
  created() {
    this.$http.get(`/agencias/${this.$store.getters.getOpAgency}`).then((r) => {
      this.agencia = r.data[0];
    });
    this.$http
      .get(`/operadores/${this.$store.getters.getOperador}`)
      .then((r) => {
        this.operador = r.data[0];
      });
    this.RetornaDataHoraAtual();
  },
  methods: {
    convertDate(date) {
      return date.split("-").reverse().join("/");
    },
    RetornaDataHoraAtual() {
      var dNow = new Date();
      var localdate =
        dNow.getDate() +
        "/" +
        (dNow.getMonth() + 1) +
        "/" +
        dNow.getFullYear() +
        " às " +
        dNow.getHours() +
        ":" +
        dNow.getMinutes();
      this.dataHora = localdate;
    },
    parseVal(str) {
      if (!str) return 0;
      return parseFloat(String(str).replace(/\./g, "").replace(",", ".")) || 0;
    },
    fmtVal(num) {
      return (num || 0).toFixed(2).replace(".", ",");
    },
    getForma(nome) {
      if (!this.resumo || !this.resumo.aggregated) return 0;
      return this.resumo.aggregated[nome] || 0;
    },
    getPix() {
      if (!this.resumo || !this.resumo.aggregated) return 0;
      const ag = this.resumo.aggregated;
      return (ag["Pix"] || 0) + (ag["PIX"] || 0);
    },
    getCartao() {
      if (!this.resumo || !this.resumo.aggregated) return 0;
      const ag = this.resumo.aggregated;
      return Object.keys(ag)
        .filter((k) => k.toLowerCase().includes("cart"))
        .reduce((sum, k) => sum + ag[k], 0);
    },
    calcTotal() {
      const abertura = this.parseVal(this.totais && this.totais.abertura);
      const fechamento = this.parseVal(this.totais && this.totais.fechamento);
      return this.fmtVal(abertura + fechamento);
    },
    calcSubtotal() {
      const total = this.parseVal(this.calcTotal());
      const pix = this.getPix();
      return this.fmtVal(total - pix);
    },
    getSectionForma(arr, ...names) {
      if (!arr) return 0;
      return arr
        .filter((item) => names.some((n) => item.formapagamento.toLowerCase() === n.toLowerCase()))
        .reduce((sum, item) => sum + (parseFloat(item.valor.replace(/\./g, "").replace(",", ".")) || 0), 0);
    },
    getSectionCartao(arr) {
      if (!arr) return 0;
      return arr
        .filter((item) => item.formapagamento.toLowerCase().includes("cart"))
        .reduce((sum, item) => sum + (parseFloat(item.valor.replace(/\./g, "").replace(",", ".")) || 0), 0);
    },
  },
};
</script>
